import React, { useState, useEffect } from "react";
import BackBtn from "../../btncomponent/BackBtn";
import Category from "./Category";
import { isAuthenticated } from "../../auth";
import DeleteCategory from "./DeleteCategory";

const Addcategory = () => {
  const [name, setName] = useState("");
  const [error, setError] = useState(false);
  const [success, setSuccess] = useState(false);
  const [cities, setCities] = useState([]);
  const [city, setCity] = useState("");

  useEffect(() => {
    fetch(`${process.env.REACT_APP_API_URL}/city`, {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
    })
      .then((res) => res.json())
      .then((data) => {
        return setCities(data);
      });
  }, []);

  const handleChangeCity = (e) => {
    setError("");
    setSuccess(false);
    setCity(e.target.value);
  };

  const handleChange = (e) => {
    setError("");
    setSuccess(false);
    setName(e.target.value);
  };

  const clickSubmit = (e) => {
    e.preventDefault();
    const id = isAuthenticated().user._id;
    const token = isAuthenticated().token;
    fetch(`${process.env.REACT_APP_API_URL}/create/new/category/${id}`, {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify({ name, city }),
    })
      .then((res) => {
        return res.json();
      })
      .catch((err) => {
        console.log(err);
      })
      .then((data) => {
        if (data.error) {
          setError(true);
          setSuccess(false);
          setName("");
        } else {
          setError("");
          setSuccess(true);
          setName("");
        }
      });
  };
  const showSuccess = () => {
    if (success) {
      return <h3 className="text-success"> Area Name created successfully</h3>;
    }
  };

  const showError = () => {
    if (error) {
      return <h3 className="text-danger ">Area Name should be unique</h3>;
    }
  };
  return (
    <div className="container mt-3">
      <BackBtn location="/admin/dashboard" />
      <br />

      <h2 className=" mb-3">Add Area</h2>
      {showSuccess()}
      {showError()}
      <div className="row">
        <div className="col-sm-6">
          <form onSubmit={clickSubmit}>
            <div className="form-group">
              <label className="text-muted">Name </label>
              <input
                type="text"
                onChange={handleChange}
                value={name}
                className="form-control"
                autoFocus
                required
              />

              <div className="form-group">
                <label className="text-muted">City</label>
                <select onChange={handleChangeCity} className="form-select">
                  <option>Please select</option>
                  {cities &&
                    cities.map((c, i) => (
                      <option key={i} value={c._id}>
                        {c.name}
                      </option>
                    ))}
                </select>
              </div>

              <button
                type="submit"
                className="btn float-right mt-3"
                style={{ backgroundColor: "#FCCE01", borderRadius: "0" }}
              >
                Create Area
              </button>
            </div>
          </form>
        </div>
        <div className="col-sm-1"></div>
        <div className="col-sm-5 mt-3">
          <Category />
        </div>
      </div>
    </div>
  );
};

export default Addcategory;
